import { useMemo } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, useParams } from 'src/routes/hooks';

import { useGetDepartment } from 'src/api';
import { useAuthContext } from 'src/auth/hooks';
// import { useAclGuard } from 'src/auth/guard/acl-guard';
import { useLocales, useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export function useNavData() {
  const params = useParams();
  const router = useRouter();

  // const checkAcl = useAclGuard();

  const { t } = useTranslate();
  const { currentLang } = useLocales();
  const curLangAr = currentLang.value === 'ar';

  const { user } = useAuthContext();
  const { id, depid } = params;

  const departmentData = useGetDepartment(depid).data;

  const data = useMemo(() => {
    const employeeItems = [
      {
        // show: checkAcl('appointments:read'),
        title: t('appointments'),
        path: paths.superadmin.unitservices.departments.appointments(id, depid),
        icon: <Iconify icon="teenyicons:appointments-solid" />,
      },
      {
        // show: checkAcl('accounting:read'),
        title: t('accounting'),
        path: paths.superadmin.unitservices.departments.accounting(id, depid),
        icon: <Iconify icon="fa6-solid:file-invoice-dollar" />,
      },
      {
        // show: true,
        title: t('feedback'),
        path: paths.superadmin.unitservices.departments.qualityControl(id, depid),
        icon: <Iconify icon="healthicons:world-care" />,
      },
      {
        // show: checkAcl('activities:read'),
        title: t('activities'),
        path: paths.superadmin.unitservices.departments.activities.root(id, depid),
        icon: <Iconify icon="fluent:shifts-activity-24-filled" />,
      },
      {
        // show: checkAcl('employees:read'), //
        title: t('employees'),
        path: paths.superadmin.unitservices.departments.employees.root(id, depid),
        icon: <Iconify icon="ic:round-group" />,
      },
      {
        // show: checkAcl('rooms:read'), //
        title: t('rooms'),
        path: paths.superadmin.unitservices.departments.rooms.root(id, depid),
        icon: <Iconify icon="ic:sharp-meeting-room" />,
      },
      {
        // show: checkAcl('work_groups:read'),
        title: t('work groups'),
        path: paths.superadmin.unitservices.departments.workGroups.root(id, depid),
        icon: <Iconify icon="fa6-solid:people-group" />,
      },
    ];
    const employeeSecDashboard = [
      {
        items: [
          {
            title: curLangAr ? departmentData?.name_arabic : departmentData?.name_english,
            path: paths.superadmin.unitservices.departments.info(id, depid),
            icon: <Iconify icon="fluent:person-info-20-filled" />,
          },
        ],
      },
      {
        subheader: t('control panel'),
        items: employeeItems,
      },
    ];

    if (!user) {
      router.replace('/');
    }

    if (user?.role === 'admin') {
      return [...employeeSecDashboard];
    }
    return [...employeeSecDashboard];
  }, [t, user, router, id, depid, departmentData, curLangAr]);

  return data;
}
